// extracted by mini-css-extract-plugin
module.exports = {"container":"_3CKzJ7IgiKdxaE3o8oMtZQ","item":"_3lzGGeo--061hNGnOq7Rth","dot":"_2e2DDcqCjAlGOIqzC0ZVO"};